import { devicesReducer } from "./ducks/devices/reducer";
import { notificationSettingsReducer } from "./ducks/notification-settings/reducer";
import { notificationReducer } from "./ducks/notification/reducer";
import { weatherReducer } from "./ducks/weather-data-dmi/reducer";
import { authReducer } from "./ducks/auth/reducer";
import { userReducer } from "./ducks/users/reducer";
import { snackbarReducer } from "./snackbar/reducer";


import { combineReducers, createStore, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";

const reducersArray = {
  devicesReducer,
  notificationReducer,
  notificationSettingsReducer,
  snackbarReducer,
  authReducer,
  weatherReducer,
  userReducer,
};

const reducerMap = {
  ...reducersArray,
};

export const reducers = combineReducers({
  ...reducersArray,
});

export type AppState = {
  [K in keyof typeof reducerMap]: ReturnType<typeof reducerMap[K]>;
};

declare const window: any;
export const store = createStore(
  reducers,
  compose(
    applyMiddleware(thunk),
    // Read: if redux devtools is defined, then return its compose function; else, return the default compose.
    (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()) ||
      compose
  )
);
